import React, { useState } from 'react';

interface FAQItem {
    question: string;
    answer: string;
}

const FAQ: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const faqs: FAQItem[] = [
        {
            question: 'What is $DUCK?',
            answer: '$DUCK is the quackiest memecoin on the Monad blockchain. Born on nad.fun, $DUCK represents the spirit of community, humor, and the belief that every duck deserves to fly to the moon. No VC funding, no insider allocations — just pure, organic quacking.',
        },
        {
            question: 'How do I buy $DUCK?',
            answer: 'You can buy $DUCK on nad.fun! Simply connect your wallet (MetaMask or any EVM wallet), make sure you have MON tokens for gas, and swap MON for $DUCK. It\'s currently in the bonding curve phase, so early birds (or ducks) get the best prices!',
        },
        {
            question: 'Is $DUCK safe? Can I get rugged?',
            answer: '90% of the token supply goes directly to the liquidity pool on nad.fun\'s bonding curve. There are no admin keys, no hidden minting functions, and no backdoors. The contract is transparent and verifiable on MonadScan. However, always DYOR — this is a memecoin and prices can be volatile.',
        },
        {
            question: 'What is the Monad network?',
            answer: 'Monad is a high-performance Layer 1 blockchain with blazing-fast transaction speeds and low gas fees. It\'s EVM-compatible, meaning you can use your existing MetaMask wallet. $DUCK chose Monad because speed matters when you\'re flying to the moon!',
        },
        {
            question: 'What is nad.fun?',
            answer: 'nad.fun is a fair launch platform on Monad where tokens are created and traded through bonding curves. It ensures fair price discovery and prevents common memecoin scams like sniping and insider trading. $DUCK is currently in its bonding curve phase on nad.fun.',
        },
        {
            question: 'What makes $DUCK different from other memecoins?',
            answer: 'While other memecoins quack the quack, $DUCK walks the walk (well, waddles). We have an active AI agent ecosystem for trading signals, a passionate community, and a duck that refuses to stop floating. Plus, we\'re on Monad — the fastest pond in crypto.',
        },
        {
            question: 'Wen moon?',
            answer: 'Sir, we are a duck. We don\'t go to the moon. We migrate. And migration season is ALWAYS. 🦆🚀',
        },
    ];

    return (
        <section id="faq" className="section faq-section">
            <h2 className="section-title">❓ FAQ</h2>
            <p className="faq-subtitle">Got questions? We got quacks... er, answers.</p>

            <div className="faq-container">
                {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`faq-item glass-card ${openIndex === index ? 'faq-open' : ''}`}
                        onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    >
                        <div className="faq-question">
                            <span className="faq-q-icon">🦆</span>
                            <h3>{faq.question}</h3>
                            <span className={`faq-toggle ${openIndex === index ? 'faq-toggle-open' : ''}`}>
                                +
                            </span>
                        </div>
                        {openIndex === index && (
                            <div className="faq-answer">
                                <p>{faq.answer}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FAQ;
